module.exports = __webpack_public_path__ + "img/db.14413a0d.png";